<template>
    <div class="days">
        <div class="label">Dage</div>

        <template v-if="isEdit">

            <article class="message is-info is-small">
                <div class="message-body">
                    <span>Opret en ny dag eller klik på værdierne for at redigere de eksisterende.</span>
                </div>
            </article>

            <article class="message is-danger is-small" v-if="messages.length > 0">
                <div class="message-body">
                    <button class="delete is-small" aria-label="delete" @click="$emit('clearMessages')"></button>
                    <p v-for="(message, index) in messages" :key="index">- {{ message }}</p>
                </div>
            </article>

            <div class="field is-grouped">
                <p class="control">
                    <InputDate
                        ref="new_date"
                        inputSize="normal"
                        :hideInput="true"
                        @select="selectDate"
                    >
                        <div class="field has-addons">
                            <button class="button">
                                <span class="icon is-small">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                <span v-if="false">Opret dag</span>
                                <span v-if="date">{{ date }}</span>
                            </button>
                            <button class="button" :disabled="false" v-if="!date">
                                Vælg dag
                            </button>
                            <button class="button is-primary" v-else @click.stop="createNew">
                                Opret
                            </button>
                        </div>
                    </InputDate>
                </p>
            </div>
        </template>

        <table class="table">
            <thead>
                <tr>
                    <th></th>
                    <th class="date" :key="day.id" v-for="day in days">
                        <template v-if="!isEdit">
                            <span v-show="!isEdit">{{ day.dateStr }}</span>
                        </template>
                        <template v-else>
                            <div v-if="isEditing(day, 'date')" class="field is-grouped">
                                <InputDate
                                    :ref="day.id + '_date'"
                                    v-model="day.dateStr"
                                    inputSize="small"
                                    @input="(value) => valueUpdated(day.id, 'dateStr', value)"
                                    @blur="setEditing(null)"
                                />
                            </div>
                            <div
                                v-else
                                @click="setEditing(day, 'date')"
                            >
                                <span>{{ day.dateStr }}</span>
                                <span class="icon" @click.stop="$emit('delete', day)">
                                    <i class="fa fa-trash has-text-danger"></i>
                                </span>
                            </div>
                        </template>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr :key="field.key" v-for="field in fields">
                    <td>{{ field.name }}</td>
                    <td class="value" :key="day.id + '-' + field.key" v-for="day in days">
                        <FormField
                            v-if="isEdit && isEditing(day, field.key)"
                            inner-container-class="has-icons-right"
                        >
                            <InputText
                                v-model="day.data[field.key]"
                                inputSize="small"
                                :ref="day.id + '_' + field.key"
                                @input="(value) => valueUpdated(day.id, field.key, value)"
                                @blur="blurField(day)"
                            />
                            <span v-if="field.inputPrice" class="icon is-right">{{ field.unit || 'DKK' }}</span>
                        </FormField>
                        <div class="value-field" v-else @click="setEditing(day, field.key)">
                            <span v-html="displayValue(day.data[field.key] || '')"></span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { FormField, InputDate, InputText } from '@elems/form'

export default {
    components: {
        FormField,
        InputDate,
        InputText,
    },

    props: {
        isEdit: { Type: Boolean, default: false },
        days: Array,
        fields: Array,
        messages: Array,
    },

    data() {
        return {
            editing: null,
            date: '',
            updated: false,
        }
    },

    methods: {

        selectDate(value) {
            this.date = value
        },

        createNew() {
            this.$emit('create', this.date)
            this.date = ''
        },

        isEditing(day, key) {
            if (!this.editing || !this.isEdit) {
                return false
            }
            return this.editing.id === day.id && this.editing.key === key
        },

        setEditing(day = null, key = '') {
            if (!this.isEdit) {
                return
            }
            if (!day) {
                return this.editing = null
            }
            this.editing = { id: day.id, key: key }
            this.$nextTick(() => {
                if (!this.$refs[day.id + '_' + key].length) {
                    return
                }
                this.$refs[day.id + '_' + key][0].$el.focus()
            })
        },

        valueUpdated(dayId, key, value) {
            this.updated = true
        },

        blurField(day) {
            if (this.updated) {
                this.$emit('saveDay', day)
            }
            this.setEditing(null)
        },

        displayValue(val) {
            if (val == '0' || val == '') {
                return '&nbsp;'
            }
            return val
        },
    }
}
</script>

<style lang="scss">
.days {
    margin-bottom: 30px;

    table {
        display: block;
        overflow-x: auto;
        white-space: nowrap;
    }
    th, td {
        padding: 5px 10px;
    }
    th.date {
        font-size: 14px;
        cursor: pointer;
    }
    th.date input {
        max-width: 100px;
    }
    td.value {
        max-width: 110px;
        text-align: right;
        cursor: pointer;
    }

    .icon {
        margin-right: 5px;
    }

    .new-day {
        position: relative;

        .confirm-day {
            position: absolute;
            right: 10px;
            top: 0;
            height: 100%;
            line-height: 100%;
            cursor: pointer;
        }
    }

    .message-body {
        position: relative;
        .delete {
            float: right;
        }
    }
}
</style>
